import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewOtherEntitiesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.OTHER_ENTITIES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createOtherEntitiesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.OTHER_ENTITIES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageOtherEntitiesPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.OTHER_ENTITIES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
